import { Color } from "src/games/shared/ColorValue";

export class UniformConfig {
    primaryColor: number;
    secondaryColor: number;
    tertiaryColor: number;
    mascotKey: string;
    type: "sleb" | "human";
}

export class Uniform extends Phaser.GameObjects.Sprite {
    primaryColor: number;
    secondaryColor: number;
    tertiaryColor: number;
    mascotKey: string;
    type: "sleb" | "human";

    tertiaryLayer: Phaser.GameObjects.Sprite;
    secondaryLayer: Phaser.GameObjects.Sprite;
    primaryLayer: Phaser.GameObjects.Sprite;
    mascot: Phaser.GameObjects.Sprite;

    constructor(scene: Phaser.Scene, x: number, y: number, texture: string) {
        super(scene, x, y, "other", "slebBase");
        this.primaryColor = 1;
        this.secondaryColor = 1;
        this.tertiaryColor = 1;
        this.mascotKey = null;
        this.type = "sleb";

        this.primaryLayer = this.scene.add.sprite(this.x, this.y, this.type, this.type + "PrimaryColor" + this.primaryColor);
        this.secondaryLayer = this.scene.add.sprite(this.x, this.y, this.type, this.type + "SecondaryColor" + this.secondaryColor);
        this.tertiaryLayer = this.scene.add.sprite(this.x, this.y, this.type, this.type + "TertiaryColor" + this.tertiaryColor);
        this.mascot = null;

        this.tertiaryLayer.setDepth(4);
        this.secondaryLayer.setDepth(3);
        this.primaryLayer.setDepth(2);

        this.setInteractive({ useHandCursor: true });
        this.setDepth(5);

        this.scene.add.existing(this);
    }

    refresh() {
        this.primaryLayer.setTexture(this.type, this.type + "PrimaryColor" + this.primaryColor);
        this.secondaryLayer.setTexture(this.type, this.type + "SecondaryColor" + this.secondaryColor);
        this.tertiaryLayer.setTexture(this.type, this.type + "TertiaryColor" + this.tertiaryColor);

        if (this.mascot != null) {
            this.mascot.setFrame(this.mascotKey);
            this.positionMascot();
        }
        else if (this.mascotKey != null) {
            this.createMascot();
        }

        this.setTexture("other", this.type + "Base");
    }

    createMascot() {
        this.mascot = this.scene.add.sprite(this.x, this.y, "other", this.mascotKey);
        this.positionMascot();
        this.mascot.setDepth(6.1);
    }

    positionMascot() {
        if (this.type === "sleb") {
            this.mascot.setPosition(this.x, this.y);
        }
        else {
            this.mascot.setPosition(this.x + 10, this.y - 175);
        }
    }

}



// WEBPACK FOOTER //
// ./src/games/UniformDesignGame/objects/Uniform.ts